module.exports = __webpack_public_path__ + "img/services-icon-1.7e2f550f.png";